import { useApi } from './use-api-call';


export const useSearchSysMenuApi = () => useApi<{ 
sysMenus: SysMenuDTO[];
        allowEdit: boolean; 
    }>('/sys-menu/search-sys-menu');

export const useGetSysMenuApi = () => useApi<{ sysMenu: SysMenuDTO; allowEdit: boolean; }>('/sys-menu/get-sys-menu/{id}');

export const useSaveSysMenuApi = () => useApi<{ sysMenu: SysMenuDTO}>('/sys-menu/save-sys-menu');

export const useDeleteSysMenuApi = () => useApi('/sys-menu/delete-sys-menu/{id}');

export interface SysMenuDTO { 
id?:number;
groupId:string;
title:string;
subTitle:string;
url:string;
iconCode:string;
iconCss:string;
imageUrl:string;
indicatorCode:string;
indicatorUnit:string;
indicatorArrow:string;
indicatorCss:string;
footer:string;
coverImage:string;
cssClass:string;
isFeed:boolean;
visible:boolean;
isWide:boolean;
isLink:boolean;
deleteRights:boolean;
templateCode:string;
roleIds:string;
separatorName:string;
}
